export default function ($translate) {
    return {
        KEYS: {
            MANDATORY: 'MANDATORY',
            OPTIONAL: 'OPTIONAL'
        },
        LABELS: {
            MANDATORY: $translate.instant('user.Mandatory'),
            OPTIONAL: $translate.instant('user.Optional')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/competence/requirement/competence/type/index.js